<template>
  <div v-if="displayParts.length" class="diff-action-headline">
    <template v-for="(part, i) in displayParts" :key="i">
      <code v-if="part.type === 'code'">
        <SearchHighlightText :text="part.text" :keyword="keyword" />
      </code>
      <b v-else-if="part.type === 'b'">
        <SearchHighlightText :text="part.text" :keyword="keyword" />
      </b>
      <SearchHighlightText
        v-else
        :text="part.text"
        :keyword="keyword"
      />
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'

import SearchHighlightText from '@/components/ApiDoc/shared/SearchHighlightText.vue'

export default {
  name: 'DiffActionHeadline',
  components: { SearchHighlightText },
  props: {
    parts: { type: Array, default: () => [] },
    fallback: { type: String, default: '' },
    keyword: { type: String, default: '' },
  },
  setup(props) {
    const displayParts = computed(() => {
      if (Array.isArray(props.parts) && props.parts.length) return props.parts
      const text = String(props.fallback || '')
      return text ? [{ type: 'text', text }] : []
    })
    return { displayParts }
  },
}
</script>
